(function () {
  function getSectionsPayload() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return {
        sections: cartDrawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };
    }

    const sections = [];
    const mainCart = document.getElementById('main-cart-items');
    if (mainCart?.dataset?.id) sections.push(mainCart.dataset.id);
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter?.dataset?.id) sections.push(cartFooter.dataset.id);
    if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
    if (document.getElementById('cart-free-shipping')) sections.push('cart-free-shipping');

    return sections.length ? { sections, sections_url: window.location.pathname } : {};
  }

  function refreshCartFromResponse(response) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && response.sections && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(response);
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'warranty-upsell',
        cartData: response,
      });
    }
  }

  async function addWarranty(control) {
    const variantId = Number(control.getAttribute('data-warranty-variant-id'));
    const quantity = Number(control.getAttribute('data-warranty-quantity')) || 1;
    const productTitle = control.getAttribute('data-warranty-product-title') || '';
    if (!variantId) return;

    control.disabled = true;
    if (control.type === 'checkbox') {
      control.checked = true;
      control.closest('.warranty-upsell__label--cart')?.classList.add('warranty-upsell__label--added');
      control.closest('.warranty-upsell')?.classList.add('warranty-upsell--added');
    }

    const payload = {
      items: [
        {
          id: variantId,
          quantity,
          properties: { För: productTitle },
        },
      ],
      ...getSectionsPayload(),
    };

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(payload);

      const response = await fetch(`${routes.cart_add_url}`, config).then((res) => res.json());
      if (response.status) {
        console.error(response);
        control.disabled = false;
        if (control.type === 'checkbox') {
          control.checked = false;
          control.closest('.warranty-upsell__label--cart')?.classList.remove('warranty-upsell__label--added');
          control.closest('.warranty-upsell')?.classList.remove('warranty-upsell--added');
        }
        return;
      }

      if (control.type === 'checkbox') {
        control.disabled = false;
        control.checked = true;
        control.setAttribute('data-warranty-locked', '');
        control.removeAttribute('data-warranty-add');
      }

      refreshCartFromResponse(response);
    } catch (error) {
      console.error(error);
      control.disabled = false;
      if (control.type === 'checkbox') {
        control.checked = false;
        control.closest('.warranty-upsell__label--cart')?.classList.remove('warranty-upsell__label--added');
        control.closest('.warranty-upsell')?.classList.remove('warranty-upsell--added');
      }
    }
  }

  document.addEventListener(
    'change',
    (event) => {
      const control = event.target.closest('.warranty-upsell__input--cart, [data-warranty-add]');
      if (!control || control.type !== 'checkbox') return;
      event.stopPropagation();

      if (control.hasAttribute('data-warranty-locked')) {
        control.checked = true;
        return;
      }

      if (!control.hasAttribute('data-warranty-add')) return;

      if (!control.checked) {
        control.checked = false;
        return;
      }
      addWarranty(control);
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (event.target.closest('.warranty-upsell__info')) return;
    const control = event.target.closest('[data-warranty-add]');
    if (!control || control.type === 'checkbox') return;
    event.preventDefault();
    addWarranty(control);
  });

  const PULSE_DURATION_MS = 3000;
  let pulseSyncTimer;

  function syncWarrantyPulses(root = document) {
    const targets = root.querySelectorAll(
      '.warranty-upsell__label--cart:not(.warranty-upsell__label--added)'
    );
    if (!targets.length) return;
    const delay = `-${performance.now() % PULSE_DURATION_MS}ms`;
    targets.forEach((el) => {
      el.style.setProperty('--warranty-pulse-delay', delay);
    });
  }

  function scheduleWarrantyPulseSync() {
    clearTimeout(pulseSyncTimer);
    pulseSyncTimer = setTimeout(() => syncWarrantyPulses(), 40);
  }

  function updateProductFormWarrantyLabels(root = document) {
    root.querySelectorAll('.warranty-upsell--checkbox').forEach((upsell) => {
      const form = upsell.closest('form') || upsell.closest('product-form')?.querySelector('form');
      if (!form) return;
      const qtyInput = form.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
      const unit = Number(upsell.getAttribute('data-warranty-unit-price')) || 99;
      const priceLabel = upsell.querySelector('[data-warranty-price-label]');
      const example = upsell.querySelector('[data-warranty-qty-example]');
      if (priceLabel) {
        priceLabel.textContent = qty > 1 ? `+${unit * qty} kr (${qty}×${unit})` : `+${unit} kr/st`;
      }
      if (example) {
        example.textContent = qty > 1 ? `(för ${qty} st)` : '(t.ex. 2 st = 198 kr)';
      }
    });
  }

  document.addEventListener('change', (event) => {
    if (event.target?.name === 'quantity') updateProductFormWarrantyLabels();
  });
  document.addEventListener('input', (event) => {
    if (event.target?.name === 'quantity') updateProductFormWarrantyLabels();
  });

  function initWarrantyUi() {
    updateProductFormWarrantyLabels();
    syncWarrantyPulses();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWarrantyUi);
  } else {
    initWarrantyUi();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      scheduleWarrantyPulseSync();
    });
  }

  const cartRoots = [document.querySelector('cart-drawer'), document.querySelector('cart-items')].filter(Boolean);
  if (cartRoots.length && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => scheduleWarrantyPulseSync());
    cartRoots.forEach((root) => observer.observe(root, { childList: true, subtree: true }));
  }
})();
